module.exports = __webpack_public_path__ + "static/media/hero.020aad49.jpg";